import Clause from "./Clause";
import ProminentWord from "./ProminentWord";
import Sentence from "./Sentence";

export {
	Clause,
	ProminentWord,
	Sentence,
};
